import React from 'react';
import DocumentVerificationStep from './DocumentVerificationStep';
import { BusinessDocumentKinds, StripeDocumentType } from '../../services/exports/Constants';

export default function BusinessDocumentStep(props) {
  return (
    <DocumentVerificationStep
      keyPrefix="Components:Verification:BusinessDocumentStep"
      documentType={StripeDocumentType.BusinessDocument}
      documentTypeOptions={BusinessDocumentKinds}
      expiryRequired={false}
      {...props}
    />
  );
}
